export const employmentRelationshipTypes = {
  public: 'Funcionário público concursado',
  public_servant_commissioned: 'Funcionário público em cargo comissionado',
  private_initiative: 'Funcionário privado de instituição financeira',
  autonome: 'Prestador autônomo',
  other: 'Outro',
}

export const kinshipRelationshipTypes = {
  spouse: 'Cônjuge',
  parent: 'Pai/mãe',
  minor_children_stepchildren: 'Filho(s)/entreado(s) menor(es) de idade',
  adult_children_stepchildren: 'Filho(s)/entreado(s) maior(es) de idade',
  siblings: 'Irmão(ã)',
  uncles: 'Tio(a)',
  nephew: 'Sobrinho(a)',
  cousin: 'Primo(a)',
  grandparents: 'Avô(ó)',
  grandchildren: 'Neto(a)',
}

export const XPKinshipRelationshipTypes = {
  spouse: 'Cônjuge',
  parent: 'Pai/mãe',
  children: 'Filho(a)',
  siblings: 'Irmão(ã)',
  uncles: 'Tio(a)',
  nephew: 'Sobrinho(a)',
  cousin: 'Primo(a)',
  grandparents: 'Avô(ó)',
  grandchildren: 'Neto(a)',
}

export const pepRelationshipTypes = {
  spouse: 'Cônjuge',
  parent: 'Pai/mãe',
  children: 'Filho(a)',
  siblings: 'Irmão(ã)',
  uncles: 'Tio(a)',
  nephew: 'Sobrinho(a)',
  cousin: 'Primo(a)',
  grandparents: 'Avô(ó)',
  grandchildren: 'Neto(a)',
  close_friend: 'Amigo próximo',
  business_partner: 'Parceiro de negócios',
}

export const restrictiveListTypes = {
  ceaf: 'Cadastro de Expulsões da Administração Federal - CEAF',
  cnep: 'Cadastro Nacional de Empresas Punidas - CNEP',
  unsc: 'Conselho de Segurança das Nações Unidas - UNSC',
  ofac: 'Interpol',
  interpol: 'Office of Foreign Assets Control - OFAC',
  ceis: 'Empresas Inidôneas e Suspensas - CEIS',
  arrest_warrant: 'Mandatos de Prisão (PF)',
  other: 'Outra lista',
}

export const COMPANY_RELATED_QUESTIONS = {
  FINANCIAL_ACTIVITIES: 'financial_activities',
  ENVIRONMENT_RELATED_ACTIVITIES: 'environment_related_activities',
  NATIONAL_PRODUCT_ACTIVITIES: 'national_product_offering_activities',
  INTERNATIONAL_PRODUCT_ACTIVITIES: 'international_product_offering_activities',
  AUTOMATION_ACTIVITIES: 'automation_activities',
}
